import { render, staticRenderFns } from "./DescrizioneMov.vue?vue&type=template&id=189ac27a"
import script from "./DescrizioneMov.vue?vue&type=script&lang=js"
export * from "./DescrizioneMov.vue?vue&type=script&lang=js"
import style0 from "./DescrizioneMov.vue?vue&type=style&index=0&id=189ac27a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports